import {Component, OnInit} from "@angular/core";
import {BaseComponent} from "../base.component";
import {LoggerService} from "../common/logger.service";
import {UserService} from "../common/user.service";
import {AdminService} from "./admin.service";
import {AlertService} from "../alert/alert.service";
import {SessionService} from "../common/session.service";

@Component({
    selector: 'admin',
    templateUrl: './admin.component.html',
    styleUrls: ['./admin.component.scss'],
    standalone: false
})
export class AdminComponent extends BaseComponent implements OnInit {

    isAdminDisabled: boolean = true;
    adminAnswer: string = '';
    wrongAnswer: string = '';

    productInfoCountry: string = "US";
    productInfoWarehouse: string = "SLC";
    productInfoLanguage: string = "en";
    productInfoUsanaId: string = "";

    productLoadCountry: string = "";
    productLoadProductId: string = "";

    syncProductLoadCountryOny: string = "";
    syncProductLoadCountry: string = "";
    syncProductLoadProductId: string = "";

    secureAdminPassword: string;
    schedulerJob: string = "CartServicesScheduler";
    schedulerTrigger: string = "CartServicesScheduler";
    job: string = "";
    trigger: string = "";

    appConfig: any;
    showAppConfigDebug: boolean = false;

    constructor(
        loggerService: LoggerService,
        userService: UserService,
        private adminService: AdminService,
        private alertService: AlertService,
        private sessionService: SessionService) {
        super(userService, loggerService);
    }

    ngOnInit(): void {
        this.sessionService.getAppConfig().subscribe((appConfig: any) => {
            this.appConfig = appConfig;
        });
    }

    clearTranslationCache(): void {
        this.adminService.clearTranslationCache().then(
            (response: any) => this.alertService.addSuccess({body: response.message}, 5000),
            (error: any) => this.displayError("Refresh Translation Cache Error:  " + this.getErrorMessage(error))
        );
    }

    loadRecommendedProducts(): void {
        this.adminService.loadRecommendedProducts().then(
            (response: any) => this.alertService.addSuccess({body: response.message}, 5000),
            (error: any) => this.displayError("Refresh Recommended Product Cache Error:  " + this.getErrorMessage(error))
        );
        this.alertService.addWarning({body: "Refresh Product Recommends Cache: This is a long running operation and may time out.  Have faith it is still working on the server."}, 7000);
    }

    clearProductCache(): void {
        this.adminService.clearProductCache().then(
            (response: any) => this.alertService.addSuccess({body: response.message}, 5000),
            (error: any) => this.displayError("Refresh Product Cache Error:  " + this.getErrorMessage(error))
        );
    }

    purgeCarts(): void {
        this.adminService.purgeShoppingCarts().then(
            (response: any) => this.alertService.addSuccess({body: response.message}, 5000),
            (error: any) => this.displayError("Purge Carts Error:  " + this.getErrorMessage(error))
        );
    }

    logProductInfo(): void {
        this.adminService.logProductInfo(this.productInfoCountry, this.productInfoWarehouse, this.productInfoLanguage, this.productInfoUsanaId).then(
            (response: any) => this.alertService.addSuccess({body: "<pre>"+response.message+"</pre>"}, -1),
            (error: any) => this.displayError("Log Product Info Error:  " + this.getErrorMessage(error))
        );
    }

    clearAllQuartzTasks(): void {
        this.adminService.clearAllQuartzTasks(this.secureAdminPassword).then(
            (response: any) => this.alertService.addSuccess({body: response.message}, 20000),
            (error: any) => this.displayError("Quartz Clear Error:  " + this.getErrorMessage(error))
        );
    }

    clearQuartzTrigger(): void {
        this.adminService.clearQuartzTrigger(this.secureAdminPassword, this.schedulerTrigger, this.trigger).then(
            (response: any) => this.alertService.addSuccess({body: response.message}, 20000),
            (error: any) => this.displayError("Quartz Clear Error:  " + this.getErrorMessage(error))
        );
    }

    clearQuartzJob(): void {
        this.adminService.clearQuartzJob(this.secureAdminPassword, this.schedulerJob, this.job).then(
            (response: any) => this.alertService.addSuccess({body: response.message}, 20000),
            (error: any) => this.displayError("Quartz Clear Error:  " + this.getErrorMessage(error))
        );
    }

    singleProductLoadByCountry(): void {
        this.adminService.singleProductLoadByCountry(this.productLoadCountry, this.productLoadProductId).then(
            (response: any) => this.alertService.addSuccess({body: response.message}, 5000),
            (error: any) => this.displayError("Reload Single Product Error:  " + this.getErrorMessage(error))
        );
    }

    syncProductsByCountryAndProductId(): void {
        this.adminService.syncProductsByCountryAndProductId(this.syncProductLoadCountry, this.syncProductLoadProductId).then(
            (response: any) => this.alertService.addSuccess({body: response.message}, 5000),
            (error: any) => this.displayError("Check for Product change Error:  " + this.getErrorMessage(error))
        );
    }
    syncProductsByCountry(): void {
        this.adminService.syncProductsByCountry(this.syncProductLoadCountryOny).then(
            (response: any) => this.alertService.addSuccess({body: response.message}, 5000),
            (error: any) => this.displayError("Check for Product change Error:  " + this.getErrorMessage(error))
        );
    }

    syncProducts(): void {
        this.adminService.syncProducts().then(
            (response: any) => this.alertService.addSuccess({body: response.message}, 5000),
            (error: any) => this.displayError("Check for all product changes Error:  " + this.getErrorMessage(error))
        );
    }


    displayError(errorMessage: string) {
        this.alertService.addFail(null, {body: errorMessage}, false, 20000);
    }

    getErrorMessage(error: any): string {
        this.log.error("Error:", error);
        if (!!error.data && !!error.data.errorMessage) {
            return error.data.errorMessage;
        }
        return error.statusText;
    }

    checkAnswer(): void {
        if (this.adminAnswer?.toLowerCase() == "phoenix") {
            this.isAdminDisabled = false;
        } else {
            this.wrongAnswer = "Wrong Answer!";
            this.isAdminDisabled = true;
        }
    }
}
